// Sprint 0078 — WhatsApp share button.
// Generic component. Drops onto any page that has a title + body context.
// Calls /whatsapp/link to get the pre-encoded wa.me URL, then opens it.
// Future swap to Cloud API: same API call, backend transparently auto-sends
// AND returns a URL placeholder; this component just opens it (or shows a
// "sent" toast when backend tells it the message was delivered).

import { App, Button, Tooltip } from 'antd'
import { WhatsAppOutlined } from '@ant-design/icons'
import { useMutation } from '@tanstack/react-query'

import { whatsappApi, openWhatsAppShare } from '@/features/notifications/api'

interface Props {
  title: string
  body: string
  entityType?: string
  entityId?: string
  buttonText?: string
  size?: 'small' | 'middle' | 'large'
}

export default function WhatsAppShareButton({
  title, body, entityType, entityId, buttonText = 'Share to WhatsApp', size = 'middle',
}: Props) {
  const { message } = App.useApp()

  const mut = useMutation({
    mutationFn: () => whatsappApi.generateLink({
      title, body, entity_type: entityType, entity_id: entityId,
    }),
    onSuccess: (data) => {
      openWhatsAppShare(data.url)
      message.success('WhatsApp opened — pick the group and tap Send')
    },
    onError: () => message.error('Could not generate share link'),
  })

  return (
    <Tooltip title="Opens WhatsApp with the message pre-filled. Pick your maintenance group, then tap Send.">
      <Button
        icon={<WhatsAppOutlined />}
        style={{ background: '#25D366', color: '#fff', borderColor: '#25D366' }}
        size={size}
        loading={mut.isPending}
        onClick={() => mut.mutate()}
      >
        {buttonText}
      </Button>
    </Tooltip>
  )
}
